export const STUDENT_CLICK_EVENTS = {
    SHOW_STUDENT: 'SHOW_STUDENT',
    HIDE_STUDENT: 'HIDE_STUDENT'
}
